import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Button } from "@mui/material";
/**
 * Standard form action buttons: a contained submit (`type="submit"`) and an
 * optional outlined cancel, side by side and centered with a sensible min
 * width (not stretched full-width). Use this on every form so button styling
 * stays consistent across the app.
 */
export var FormActions = function (_a) {
    var submitLabel = _a.submitLabel, onCancel = _a.onCancel, _b = _a.cancelLabel, cancelLabel = _b === void 0 ? "Cancel" : _b, _c = _a.isSubmitting, isSubmitting = _c === void 0 ? false : _c;
    return (_jsxs(Box, { sx: {
            display: "flex",
            justifyContent: "center",
            gap: 2,
            mt: 3,
            mb: 2,
        }, children: [_jsx(Button, { type: "submit", variant: "contained", disabled: isSubmitting, sx: { minWidth: 120 }, children: submitLabel }), onCancel && (_jsx(Button, { variant: "outlined", onClick: onCancel, disabled: isSubmitting, sx: { minWidth: 120 }, children: cancelLabel }))] }));
};
